import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { UpdateRetailOrderResult } from "../types/UpdateRetailOrderResult";

export const useApproveQuality = (
	retailOrderID: number,
	onSuccess: (result: UpdateRetailOrderResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/approve-quality",
				{
					retailOrderID: retailOrderID
				}) as UpdateRetailOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when approving quality: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
